<template>
	<apexchart
		:type="adjustedConfig.type"
		:series="adjustedConfig.series"
		:width="adjustedConfig.width"
		:height="adjustedConfig.height"
		:options="adjustedConfig.options"
	/>
</template>

<script>
export default {
	props: {
		config: {
			type: Object,
			required: true,
		},
	},
	computed: {
		adjustedConfig() {
			const config = {
				options: {},
			}

			if (this.config) {
				if (typeof this.config.type == "string") {
					config.type = this.config.type
				}
				if (Array.isArray(this.config.series)) {
					config.series = this.config.series
				}
				if (typeof this.config.width == "string" || typeof this.config.width == "number") {
					config.width = this.config.width
				}
				if (typeof this.config.height == "string" || typeof this.config.height == "number") {
					config.height = this.config.height
				}
				if (typeof this.config.options == "object") {
					config.options = { ...this.config.options }
				}
			}

			const pie_chart_colors = ["#00B4DB", "#0083B0", "#006080", "#4ECDC4", "#2B908F", "#D4526E", "#F9A3A4"] //['#B3F1FF', '#66E3FF', '#1AD5FF', '#00A7CC', '#006880', '#002A33']
			const other_chart_colors = ["#00B4DB", "#0083B0", "#006080", "", "", ""]

			config.options = {
				chart: {
					toolbar: {
						show: false,
					},
					...(config.options.chart || {}),
				},
				/*theme: {
					monochrome: {
						enabled: true,
						shadeTo: 'dark',
						color: '#00B4DB', // site colors: { primary: '#0083B0', secondary: '#00B4DB' }
						shadeIntensity: 0.5
					}
				},*/
				colors: config.type == "pie" || config.type == "donut" ? pie_chart_colors : other_chart_colors,
				//colors: ['#00B4DB', '#13D8AA', '#D4526E', '#0083B0', '#F9A3A4', '#FF9800', '#775DD0', '#546E7A'],
				...config.options,
				responsive: [
					{
						// mobile
						breakpoint: 768,
						options: {
							chart: {
								height: 500,
							},
						},
					},
					{
						// tablet
						breakpoint: 1023,
						options: {},
					},
					{
						// desktop
						breakpoint: 1215,
						options: {},
					},
					{
						// widescreen
						breakpoint: 1407,
						options: {},
					},
				],
			}

			return config
		},
	},
}
</script>
